
import React from 'react';
import ChildrensDay from 'views/ChildrensDay';

const ChildrensDayPage = () => {
  return <ChildrensDay />;
};

export default ChildrensDayPage;
